import { ref, watch } from 'vue'

// Module-level singleton: the drawer's open/closed state is global (toggled from the navbar,
// read by App.vue), not per-component — there is exactly one drawer for the whole app.
const isOpen = ref(false)

// Mirrored onto <body> so global CSS (e.g. shifting the Chatwoot bubble out of the
// drawer's way) can react to the drawer without every consumer wiring it up itself.
watch(isOpen, (open) => {
  document.body.classList.toggle('assistant-drawer-open', open)
}, { immediate: true })

export function useAssistantDrawer() {
  return {
    isOpen,
    open: () => { isOpen.value = true },
    close: () => { isOpen.value = false },
    toggle: () => { isOpen.value = !isOpen.value },
  }
}
